export default "__VITE_ASSET__DKQyT67Y__"